import { createRef, RefObject, useEffect, useState, useMemo } from "react";

export default function useIsInViewport(ref) {
    const [isIntersecting, setIsIntersecting] = useState(false);
  
    const observer = 
    useMemo(
      () =>
        new IntersectionObserver(([entry]) =>{
        if(entry.boundingClientRect.top <= 200)
          setIsIntersecting(!entry.isIntersecting)
        }
        ),
      [],
    );
  
    useEffect(() => {
      if(ref.current){
          observer.observe(ref.current);
      }
  
      return () => {
        observer.disconnect();
      };
    }, [ref]);
  
    return isIntersecting;
  }